import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom"
import {Instrument} from "../../gen/api";
import './SearchResults.scss';
import {Box, Menu, MenuItem, Typography} from "@mui/material";
import { DataGrid, GridColDef, GridColumnHeaderParams } from "@mui/x-data-grid";
import { mainTheme } from "../../style/main-theme";

type Props = {
  instruments: Instrument[]
}

export default function SearchResults({instruments}: Props) {
    const navigate = useNavigate()
    //const navigateToInstrumentHandler = (instrumentID: string | undefined) => navigate(`/show/`+instrumentID)
    //const navigateToInstrumentHandler = (instrumentID: string | undefined) => window.open(`show/`+instrumentID, '_blank')
    
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isMiddleScreen, setIsMiddleScreen] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 600);
        setIsMiddleScreen(window.innerWidth >= 600 && window.innerWidth < 1200);
      };
      
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


    const columns: GridColDef[] = isSmallScreen ? [
      {field: 'name', headerName: 'Titel', flex: 1.5, headerClassName: 'super-app-theme--header'},
      {field: 'openAccess', headerName: 'Publikation', flex: 1, headerClassName: 'super-app-theme--header'}
    ] : isMiddleScreen ? [
      {field: 'name', headerName: 'Titel', flex: 1.5, headerClassName: 'super-app-theme--header'},
      {field: 'formOfSurvey', headerName: 'Erhebungsform', flex: 1, headerClassName: 'super-app-theme--header'},
      {field: 'targetDimension', headerName: 'Zieldimension', flex: 1, headerClassName: 'super-app-theme--header'},
      {field: 'openAccess', headerName: 'Publikation', flex: 1, headerClassName: 'super-app-theme--header'}      
    ] : [
        {field: 'name', headerName: 'Titel', flex: 1.5, headerClassName: 'super-app-theme--header'},
        {field: 'formOfSurvey', headerName: 'Erhebungsform', flex: 1, headerClassName: 'super-app-theme--header'},
        {field: 'targetDimension', headerName: 'Zieldimension', flex: 1, headerClassName: 'super-app-theme--header'},
        {field: 'rater', headerName: 'Rater', flex: 1, headerClassName: 'super-app-theme--header'},
        //{field: 'ageRange', headerName: 'Altersrange (in Jahren)', flex: 1, headerClassName: 'super-app-theme--header'},
        {
          field: 'ageRange',
          headerName: 'Altersrange\n(in Jahren)',
          flex: 1,
          headerClassName: 'super-app-theme--header',
          renderHeader: (params: GridColumnHeaderParams) => (
            <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="body2">
              Altersrange
            </Typography>
            <Typography variant="body2">(in Jahren)</Typography>
          </Box>
          )
      },
      {field: 'items', headerName: 'Items', flex: 1, headerClassName: 'super-app-theme--header'},
      //{field: 'processingTime', headerName: 'Bearbeitungsdauer (in Minuten)', flex: 1, headerClassName: 'super-app-theme--header'},
      {
        field: 'processingTime',
        headerName: 'Bearbeitungsdauer\n(in Minuten)',
        flex: 1,
        headerClassName: 'super-app-theme--header',
        renderHeader: (params: GridColumnHeaderParams) => (
          <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="body2">
          Bearbeitungsdauer
          </Typography>
          <Typography variant="body2">(in Minuten)</Typography>
        </Box>
        )
    },
      {field: 'openAccess', headerName: 'Publikation', flex: 1, headerClassName: 'super-app-theme--header'}
    ]
    const rows = instruments.map((instrument) => ({
        id: instrument.id,
        name: instrument.name,
        formOfSurvey: instrument.formOfSurvey,
        targetDimension: instrument.targetDimension,
        rater: instrument.rater,
        ageRange: instrument.ageRange,
        items: instrument.items,
        processingTime: instrument.processingTime,
        openAccess: instrument.openAccess
    }))

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [selectedInstrumentId, setSelectedInstrumentId] = useState(null);


  return (
      <>
        <Grid item xs={12}>
          <h2>{instruments.length} Ergebnisse</h2>
        </Grid>
        <Grid item xs={12}>
          <Paper>
          <DataGrid
              rows={rows}
              columns={columns}
              pageSizeOptions={[10]}
              onRowClick={(params, event) => {
                setAnchorEl(event.currentTarget as HTMLElement);
                setSelectedInstrumentId(params.row.id);
                //navigateToInstrumentHandler(event.row.id);
              }}
              sx={{
                height: 650,
                width: '100%',
                '& .super-app-theme--header': {
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    backgroundColor: '#f5f5f5'
                },
                '& .MuiDataGrid-row': {
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5'
                    }
                }
              }}
              //components={{NoRowsOverlay: CustomNoRowsOverlay}}
              getRowHeight={() => 'auto'}
              getEstimatedRowHeight={() => 100}
              getRowSpacing={({isFirstVisible, isLastVisible}) => ({
                top: isFirstVisible ? 8: 4,
                bottom: isLastVisible ? 8: 4,
              })}
              />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{sx: { backgroundColor: mainTheme.palette.primary.main }}}
              MenuListProps={{
                sx: {
                  padding: 0,         // remove internal padding
                  minWidth: 0,        // optional: shrink width
                },
              }}
            >
              <MenuItem
                sx={{ padding: '2px 2px', minHeight: 'unset', color: mainTheme.palette.primary.contrastText }}
                onClick={() => {
                  navigate(`/show/${selectedInstrumentId}`);
                  setAnchorEl(null);
                }}
              >
                Instrument anzeigen
              </MenuItem>
              <MenuItem
                sx={{ padding: '2px 2px', minHeight: 'unset', color: mainTheme.palette.primary.contrastText }}
                onClick={() => {
                  const url = `show/${selectedInstrumentId}`;
                  window.open(url, '_blank');
                  setAnchorEl(null);
                }}
              >
                In neuem Tab öffnen
              </MenuItem>
            </Menu>
          </Paper>
        </Grid>
      </>
  );
}


const CustomNoRowsOverlay = () => {
  return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      }}>
        <p>Es wurden keine Instrumente gefunden, die den Filterkriterien entsprechen.</p>
      </div>)
}
